import React from 'react';
import { Outlet } from 'react-router-dom';
import MaterialHeader from './MaterialHeader';

const MaterialDatabase = () => {
  return (
    <div>
      <MaterialHeader />
      <Outlet />
    </div>
  );
};

export default MaterialDatabase;
